<template>
	<div id="app" style="position: relative;">
		<div class="header-fixed">
			<div class="header">
				<div class="logo_img_div" @click="logoClick">
					<img class="logo_img" src="../assets/logoWhite.png">
				</div>
				<!-- 导航栏 -->
				<div class="menu_index f12">
					<div style="cursor: pointer;" v-for="(item,index) in navlist" :key="item.index"
						@click="goToPage(item.value)" class="headerTitle"
						:class=" headerTitle == index ? 'activeHeaertitle' : '' ">
						{{item.label}}
					</div>
				</div>
			</div>
		</div>
		<!-- banner -->
		<div>
			<el-carousel class="banner" direction="vertical">
				<el-carousel-item v-for="(item,index) in bannerList" :key="index" style="height: 400px;">
					<img :src="item.imageUrl" class="slider_img" style="cursor: pointer;" @click="showPopup">
				</el-carousel-item>
			</el-carousel>
		</div>

		<div class="container" style="clear: both;">
			<router-view></router-view>
		</div>
		<div class="indexButtom">
			<div class="elRow" :class="headerTitle == 0 ? 'w-60' : 'w-100'">
				<div class="logo-class">
					<img class="logoImg" src="../assets/logoRed.png" />
				</div>
				<div class="center f20 intro">
					<div class="text">{{footInfor.englishMsg}}</div>
					<div class="text">{{footInfor.chineseMsg}}</div>
				</div>
				<div class="elRol">
					<div class="elColumn">
						<img :src="routineImage || '../../static/other/yundangpu.png'" class="image-class" />
						<div class="title">微信小程序</div>
					</div>
					<div class="elColumn">
						<img :src="weixinImage ||'../../static/other/weixinsm.png' " class="image-class" />
						<div class="title">微信公众号</div>
					</div>
				</div>
			</div>
		</div>
		<!--底部公用 -->
		<div class="publicButtom f12">
			<div class="logo">
				<img src="../assets/logoWhite.png">
			</div>
			<div class="companyInfor">
				<div class="topCom">
					<div>地址：{{companyInfor.address}}</div>
					<div>企业名称：{{companyInfor.name}}</div>
				</div>
				<div class="bottomCom">{{footInfor.hotLine}}</div>
			</div>

			<div class="line"></div>
			<div class="footer_font footer-class">
				<div>
					<a href="https://beian.miit.gov.cn/" target="_blank" style="color: #fff">
						{{footInfor.icpInfo}}
					</a>
				</div>
				<div>
					<a href="https://qlximg.xiaoyatou.top/certificate/yingyezhizhao.jpeg" target="_blank"
						style="color: #fff">
						{{footInfor.copyRight}}
					</a>
				</div>
			</div>
		</div>
		<!-- 触底 -->
		<div id="back_to_top" ref="btn" @click="backTop">
			<p style="font-size: 0.625rem; font-weight: bold">TOP</p>
			<img src="../assets/other/launch.png" style="height: 45px;width: 35px" />
		</div>
		<Popup :visible="popupVisible" :content="popupContent" @close="closePopup" />
	</div>
</template>

<script>
	import Popup from "../components/popup.vue";
	export default {
		name: "Layout",
		components: {
			Popup
		},
		data() {
			return {
				popupVisible: false,
				popupContent: '这是一个弹窗',
				headerTitle: 0,
				bannerList: [],
				screeWith: 0,
				footInfor: {},
				navlist: [],
				routineImage: '',
				weixinImage: '',
				scroll: '',
				timer: '',
				seen: true,
				currentMenu: '首页',
				logoImgHeight: 0, //容器高度
				screeWith: 0, //浏览器宽度
				companyInfor: {},
			}
		},
		async mounted() {
			if (this.isMobile()) {
				location.href = "https://qw.yundangpu.vip";
			}

			let type = this.$route.query.id;
			if (type) {
				this.headerTitle = type;
			}
			await this.getIndexAndFoot();
		},
		methods: {
			showPopup() {
				this.popupVisible = true;
			},
			closePopup() {
				this.popupVisible = false;
			},
			async getIndexAndFoot() {
				let res = await this.util.request({
					url: `/sy/website/getIndexAndFoot`,
					method: 'GET',
					data: {},
					type: 1
				});
				if (res.status === 200) {
					this.footInfor = res.data.footInfoIndex;
					this.routineImage = res.data.routineImage;
					this.weixinImage = res.data.weixinImage;
					this.companyInfor = res.data.companyInfoIndex;
					localStorage.setItem('routineImage', this.routineImage);
					localStorage.setItem('weixinImage', this.weixinImage);
					this.navlist = res.data.indexList;
					this.bannerList = this.navlist[this.headerTitle].bannerList;
				} else {
					console.log(res.statusText);
				}
			},
			goToPage(value) {
				this.headerTitle = value;
				this.bannerList = this.navlist[value].bannerList;
				switch (value) {
					case "0":
						this.$router.push({
							path: '/',
							query: {
								id: value
							}
						}, onComplete => {}, onAbort => {})
						break;
					case "1":
						this.$router.push({
							path: '/onlineRecycling',
							query: {
								id: value
							}
						}, onComplete => {}, onAbort => {})
						break;
					case "2":
						this.$router.push({
							path: '/deposit',
							query: {
								id: value
							}
						}, onComplete => {}, onAbort => {})
						break;
					case "3":
						this.$router.push({
							path: '/contactUs',
							query: {
								id: value
							}
						}, onComplete => {}, onAbort => {})
						break;
					case "4":
						this.$router.push({
							path: '/cooperation',
							query: {
								id: value
							}
						}, onComplete => {}, onAbort => {})
						break;
					case "5":
						this.$router.push({
							path: '/sendSell',
							query: {
								id: value
							}
						}, onComplete => {}, onAbort => {})
						break;
						// 其他case分支
					default:
						console.log("未知类型");
				}
			},
			// 判断是否是手机端，如果是，返回true
			isMobile() {
				let flag = navigator.userAgent.match(
					/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
					)
				return flag
			},
			backTop() { //当点击标签的时候,使用animate在200毫秒的时间内,滚到顶部
				this.timer = setInterval(() => {
					let osTop = document.documentElement.scrollTop || document.body.scrollTop;
					let ispeed = Math.floor(-osTop / 5)
					document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
					if (osTop === 0) {
						clearInterval(this.timer)
					}
				}, 30)
			},
			logoClick() {
				this.headerTitle = 0;
				this.$router.push({
					path: '/',
					query: {
						id: 0
					}
				}, onComplete => {}, onAbort => {})
			}
		},

	}
</script>
<style lang="less">
	.indexButtom {
		background-color: #f9f9f9;
		position: relative;
		;
		height: 130px;

		.elRow {
			height: 120px;
			align-items: center;
			display: flex;
			justify-content: space-between;
			flex: 1;
			// width: 60%;
			background-color: #F4F6F7 !important;
			position: absolute;
			top: -30px;
			left: 20%;

			.center {
				letter-spacing: 5px;
				line-height: 25px;
				display: flex;
				flex-direction: column;
				align-items: center;
				font-weight: bold;
				font-family: "华文行楷";
			}
		}

		.logo-class {
			margin-left: 3%;
		}

		.logoImg {
			width: 75px;
		}
	}

	// 2024-02-28 start

	.publicButtom {
		background-color: #222222;

		.logo {
			display: flex;
			justify-content: center;
			padding: 15px 0 25px 0;
			width: 60px;
			height: 60px;
		}

		.logo,
		.top,
		.companyInfor {
			width: 60%;
			margin: auto;
		}

		.companyInfor {
			color: #fff;

			.topCom {
				display: flex;
				justify-content: space-between;
			}

			.bottomCom {
				margin-top: 10px;
			}
		}

		.line {
			height: 1px;
			width: 100%;
			margin: auto;
			margin-top: 35px;
			background-color: #fff;
		}

		.footer_font {
			width: 75%;
			margin-top: 20px;
			padding-bottom: 15px;
		}

		.footer_font a {
			color: #fff;
			list-style: none;
		}
	}


	//2024-02-28 end

	.image-class {
		width: 65px;
		height: 65px;
	}

	.footer-class {
		margin: auto;
		display: flex;
		justify-content: space-between;
	}

	/* 适配问题 */
	@media screen and (min-width:1300px) {
		#menu_index {
			display: block !important;
		}
	}

	@media screen and (max-width:1300px) {
		#menu_index {
			display: none !important;
		}

		.xiaochengxu {
			margin-right: 5% !important;
		}
	}

	@media screen and (max-width:800px) {
		.weixinsm[data-v-005bfc5a] {
			margin-right: 30%;
		}
	}

	@media screen and (max-width: 600px) {

		.weixinsm img,
		.xiaochengxu img {
			width: 64px !important;
			height: 64px !important;
			display: block;
		}
	}

	/* 导航栏 */
	.header {
		width: 70%;
		margin: auto;
		height: 50px;
		display: flex;
		align-items: center;
		display: flex;
		justify-content: space-between;

		.logo_img_div {
			display: flex;
			justify-content: center;
			padding-top: 15px;
			width: 10%;

			.logo_img {
				width: 100px;
				// height: 70px;
			}
		}

		.el-menu-demo {
			background: none;
			color: #fff;
		}

		.menu_index {
			width: 40%;
			display: flex;
			justify-content: space-around;
			letter-spacing: 2px;
		}

		.activeHeaertitle::after {
			display: flex;
			justify-content: space-around;
			content: '.';
			font-size: 0;
			position: absolute;
			height: 2px;
			width: 100%;
			background: white;
			border-radius: 2px;
			left: 0;
			bottom: -10px;

		}

		.headerTitle {
			position: relative;
			color: #fff;
			display: flex;
			font-size: 20rpx;
			align-items: center;
			text-align: center;
		}
	}

	.headerTitle:last-child .line {
		display: none;
	}

	/* 服务热线 */
	.phone {
		font-weight: bold;
		color: #f00 !important;
	}

	.phone img {
		width: 23rpx;
		height: 23rpx;
	}

	.el-menu-item.is-active {
		border-bottom: 5px solid #FFCC00 !important;
	}

	.header-fixed {
		justify-content: flex-end;
		display: flex;
		width: 100%;
		background: none;
		z-index: 999;
		position: absolute;
	}


	#back_to_top {
		position: fixed;
		bottom: 60px;
		right: 30px;
		cursor: pointer
	}


	@media screen and (max-device-width: 415px) {
		#back_to_top {
			position: fixed;
			bottom: 50px;
			right: 5px;
			cursor: pointer
		}

		.footer_font {
			font-size: 0.875rem;
		}

		#menu_index {
			float: right;
			width: auto;
			height: 100%
		}

	}

	.header-important {
		float: left;
		margin-left: 6px;
		align-self: center;
	}

	.footer {
		display: flex;
		align-items: center;
		margin: 10px auto;
		width: 90%;
	}

	a {
		text-decoration: none;
	}

	a:visited {
		text-decoration: none;
	}

	a:hover {
		text-decoration: none;
	}

	a:active {
		text-decoration: none;
	}

	.elRol {
		margin-right: 3%;
		display: flex;

		.elColumn {
			margin-left: 5px;
			display: flex;
			flex-direction: column;
			align-items: center;

			.title {
				font-size: 12px;
			}
		}
	}



	/* 清除banner滾動條 */
	.el-carousel--horizontal {
		overflow-x: hidden;
		overflow-y: hidden;
	}

	.el-carousel__indicator.is-active {
		border-bottom: 2px solid #ff717b !important;
	}

	.border_parent {
		width: 90%;
		margin: auto;
	}



	.banner {
		height: 400px;
		position: relative;
		overflow: hidden;

		.slider_img {
			position: absolute;
			top: 0;
			left: 50%;
			transform: translateX(-50%);
			width: 100%;
			height: 100%;
		}
	}

	.el-carousel__item h3 {
		color: #475669;
		font-size: 18px;
		opacity: 0.75;
		line-height: 300px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	}


	.slide-wrapper {
		margin-top: 2px;
		width: 575px;
		height: 320px;
		overflow: hidden;
	}

	.slide-wrapper .slide-container {
		position: relative;
		top: 0;
		left: 0;
		width: 100%;
	}

	.slide-container .slide-item {
		display: flex;
		width: 100%;
		height: 40px;
		line-height: 40px;
		/* margin: 20px 0; */
		margin-top: 20px;
		font-size: 14px;
		cursor: pointer;
		box-sizing: border-box;
	}

	.indexButtom .elRow .intro {
		font-family: "YouSheBiaoTiYuan";
	}

	.w-60 {
		// left: 0% !important;
		// justify-content: space-around !important;
		width: 60% !important;
		// background-color: #f9f9f9 !important;
	}

	.w-100 {
		left: 0% !important;
		justify-content: space-around !important;
		width: 100% !important;
		background-color: #f9f9f9 !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/Layout.vue